var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6643 19.9897H5.33488C3.88835 20.0796 2.46781 19.5781 1.3989 18.6011C0.421899 17.5312 -0.0795886 16.1107 0.0103195 14.6652V5.33482C-0.0795886 3.88932 0.4209 2.46878 1.3979 1.39889C2.46781 0.421895 3.88835 -0.0795878 5.33488 0.0103194H14.6643C16.1089 -0.0795878 17.5284 0.420896 18.5973 1.39789C19.5733 2.46878 20.0758 3.88832 19.9899 5.33482V14.6652C20.0788 16.1107 19.5783 17.5312 18.6013 18.6011C17.5314 19.5781 16.1109 20.0796 14.6643 19.9897Z",
    fill: "#F9B42A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_81_7114",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6643 19.9897H5.33488C3.88835 20.0796 2.46781 19.5781 1.3989 18.6011C0.421899 17.5312 -0.0795886 16.1107 0.0103195 14.6652V5.33482C-0.0795886 3.88932 0.4209 2.46878 1.3979 1.39889C2.46781 0.421895 3.88835 -0.0795878 5.33488 0.0103194H14.6643C16.1089 -0.0795878 17.5284 0.420896 18.5973 1.39789C19.5733 2.46878 20.0758 3.88832 19.9899 5.33482V14.6652C20.0788 16.1107 19.5783 17.5312 18.6013 18.6011C17.5314 19.5781 16.1109 20.0796 14.6643 19.9897Z",
    fill: "#F9B42A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_81_7114)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.9451,
    y: -2.43854,
    width: 13.7557,
    height: 29.9169,
    transform: "rotate(42.5542 20.9451 -2.43854)",
    fill: "#FFA64D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0545 8.39756L8.50177 14.9829C8.16099 15.3146 7.7131 15.5 7.24574 15.5H4.95762C4.83105 15.5 4.71421 15.4512 4.62658 15.3634C4.53895 15.2756 4.5 15.1585 4.5 15.0317L4.55842 12.7195C4.56816 12.261 4.75315 11.8317 5.07446 11.5098L9.71885 6.8561C9.79675 6.77805 9.93306 6.77805 10.011 6.8561L11.6399 8.47854C11.747 8.58488 11.9028 8.65415 12.0683 8.65415C12.4286 8.65415 12.7109 8.36146 12.7109 8.01024C12.7109 7.83463 12.6428 7.67854 12.5357 7.56146C12.5065 7.52244 10.9554 5.97805 10.9554 5.97805C10.858 5.88049 10.858 5.71463 10.9554 5.61707L11.6078 4.95366C12.2114 4.34878 13.1851 4.34878 13.7888 4.95366L15.0545 6.22195C15.6485 6.81707 15.6485 7.79268 15.0545 8.39756Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.64ec7a06.svg";
export { ForwardRef as ReactComponent };